import React from 'react';
import { Stack } from '@mui/material';
import {
  TripMatchChips,
  TravelerTagChips,
  OtherChips,
} from '@marageti/z4-lib';
import { ReferralType, TripMatchStatus } from '@marageti/z4-sdk/lib/travel';
import { TravelerTags } from '@marageti/z4-sdk/lib/people';

const {
  ChipPending,
  ChipAccepted,
  ChipPartnerDeclined,
  ChipActive,
  ChipSold,
  ChipPostponed,
  ChipInactive,
  ChipTravelerCanceled,
  ChipPartnerCanceled,
  ChipZicassoCanceled,
  ChipZicassoMatchError,
  ChipSoldCanceled,
  ChipRefundedCanceled,
} = TripMatchChips;
const {
  ChipVIP,
  ChipRedFlag,
  ChipBadApple,
  ChipTravelAgent,
  ChipJunk,
  ChipFOBY,
} = TravelerTagChips;
const { ChipPRL, ChipRepeat } = OtherChips;

const TripMatchChipList = ({
  chips,
}: {
  chips: string[],
}) => {
  if (chips.length === 0) {
    return null;
  }

  return (
    <Stack
      direction="row"
      spacing={0.5}
    >
      {chips.map((chip: string) => {
        switch (chip) {
          case TripMatchStatus.MatchPending:
            return <ChipPending key={chip} />;
          case TripMatchStatus.MatchAccepted:
            return <ChipAccepted key={chip} />;
          case TripMatchStatus.MatchPartnerDeclined:
            return <ChipPartnerDeclined key={chip} />;
          case TripMatchStatus.MatchActive:
            return <ChipActive key={chip} />;
          case TripMatchStatus.MatchSold:
            return <ChipSold key={chip} />;
          case TripMatchStatus.MatchPostponed:
            return <ChipPostponed key={chip} />;
          case TripMatchStatus.MatchInactive:
            return <ChipInactive key={chip} />;
          case TripMatchStatus.MatchTravelerCanceled:
            return <ChipTravelerCanceled key={chip} />;
          case TripMatchStatus.MatchPartnerCanceled:
            return <ChipPartnerCanceled key={chip} />;
          case TripMatchStatus.MatchZicassoCanceled:
            return <ChipZicassoCanceled key={chip} />;
          case TripMatchStatus.MatchZicassoMatchError:
            return <ChipZicassoMatchError key={chip} />;
          case TripMatchStatus.MatchSoldCanceled:
            return <ChipSoldCanceled key={chip} />;
          case TripMatchStatus.MatchRefundedCanceled:
            return <ChipRefundedCanceled key={chip} />;
          case TravelerTags.VIP:
            return <ChipVIP key={chip} />;
          case TravelerTags.BAD_APPLE:
            return <ChipBadApple key={chip} />;
          case TravelerTags.RED_FLAG:
            return <ChipRedFlag key={chip} />;
          case TravelerTags.TRAVEL_AGENT:
            return <ChipTravelAgent key={chip} />;
          case TravelerTags.JUNK:
            return <ChipJunk key={chip} />;
          case ReferralType.OneTimePartnerReferral:
          case ReferralType.LifetimePartnerReferral:
            return <ChipPRL key={chip} />;
          case 'REPEAT_TRAVELER':
            return <ChipRepeat key={chip} />;
          case TravelerTags.FOBY:
            return <ChipFOBY key={chip} />;
          default:
            return null;
        }
      })}
    </Stack>
  );
};

export default TripMatchChipList;
